export const environment = {
    production: false,
    apiUrl3: 'https://localhost:7293/api/v1/',
    apiUrl: 'https://uat.applications.gurudevsiddhapeeth.in/api/v1/',
    isJsonShow: false,
    appTitle: "KBL 2",
    yearRange: {
      past: 70, // 70 years before current year
      future: 100 // 100 years after current year HD
    },

    // isJsonShow: false,
    // appTitle: "Gurudev Siddha Peeth",
  };


  // https://uat.applications.gurudevsiddhapeeth.in